import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "element-ui/lib/locale/lang/en";
import zhCNLocale from "element-ui/lib/locale/lang/zh-CN";
import myLocale from "element-ui/lib/locale/lang/ms";
import thLocale from "element-ui/lib/locale/lang/th";
import viVNLocale from "element-ui/lib/locale/lang/vi";
import sbEnLocale from "@gtech/speedbiz-ui/src/locale/lang/en";
import sbZhCNLocale from "@gtech/speedbiz-ui/src/locale/lang/zh-CN";
import sbMyCNLocale from "@gtech/speedbiz-ui/src/locale/lang/my";
import sbThCNLocale from "@gtech/speedbiz-ui/src/locale/lang/th";
import sbViVnLocale from "@common/src/i18n/locales/speedbiz-ui/vi-VN";
import countryConf from "@/config/country";
import { getCountry } from "@common/src/utils/utils";

Vue.use(VueI18n);
const elementLocale = {
  "en-US": enLocale,
  "zh-CN": zhCNLocale,
  "ms-MY": myLocale,
  "th-TH": thLocale,
  "vi-VN": viVNLocale
};
const speedbizLocale = {
  "en-US": sbEnLocale,
  "zh-CN": sbZhCNLocale,
  "ms-MY": sbMyCNLocale,
  "th-TH": sbThCNLocale,
  "vi-VN": sbViVnLocale
};
function loadLocaleMessages() {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = { ...locales(key), ...elementLocale[locale], ...speedbizLocale[locale] };
    }
  });
  return { ...messages };
}

function getCountryWrapper() {
  return process.env.NODE_ENV === "development" ? process.env.country : getCountry();
}

// 设置默认语言
const lang = localStorage.getItem("se_lang") || countryConf[getCountryWrapper()].lang;

const i18n = new VueI18n({
  locale: lang, // set locale
  messages: loadLocaleMessages(), // set locale messages
  fallbackLocale: "zh-CN"
});
window._I18N = i18n;
localStorage.setItem("se_lang", lang);
export default i18n;
